import { CONFIG } from '../config'
import { WEIXIN } from '../weixin'
import { QQ } from './qq'
import { WEB } from './web';

var SHARE = {
    initConfigShare() {
        if(CONFIG.platform == 'qq') {
            QQ.initConfigShare();
        }else if(CONFIG.platform == 'wechat') {
            WEIXIN.initConfigShare();
        }else if(CONFIG.platform == 'web'){
            WEB.setDocumentTitle();
        }
    }
}

export {
    SHARE
}
